export const commandTemplateValueTypes = {
    nonvalueFlag: "nonvalue-flag",
    valueFlag: "value-flag",
    value: "value",
    selection: "selection",
}
